import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {StudyPageComponent} from './study-page/study-page.component';

const routes: Routes = [
  { path: '*', component: StudyPageComponent},
  { path: '', component: StudyPageComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudyRoutingModule { }



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/study/study-routing.module.ts